import { ListOffer } from '~/lib/goliath/offers';
import { Offer } from '~/lib/goliath/offer-by-slugs';

function getTelekomContractLink(offer: ListOffer | Offer): string | undefined {
  if (!offer?.product || !('externalLinks' in offer.product)) return undefined;
  const externalLinks = offer?.product?.externalLinks;
  return externalLinks?.oneShopUrl || undefined;
}

function getTelekomContractLinkText(
  path: string | undefined | null = null,
  hasSmartphoneCategory = false
) {
  const isSmartphone =
    (path && path.split('/')?.[1] === 'smartphones-und-handys') || hasSmartphoneCategory;
  if (isSmartphone) return 'Zum Smartphone-Angebot mit Vertrag';
  return 'Zum Produkt-Angebot mit Vertrag';
}

export { getTelekomContractLink, getTelekomContractLinkText };
